import classNames from 'classnames'
import { ISupportTopic } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { DropdownAutocomplete } from 'legacy/lut/components/widgets/public/partner360/editors/DropdownAutocomplete'

import { Textarea } from 'core-components/library/inputs'
import { Crud } from 'core/types/Crud'

import { IColumn } from '../../../styledComponents/styledTable/types'
import styles from '../SupportTopics.module.scss'
import { getTalkingPointsThView } from '../tableThView/getTalkingPointsThView'
import { getTopicAreaThView } from '../tableThView/getTopicAreaThView'

import { isBottomArrowIsNotVisible } from './isBottomArrowIsNotVisible'
import { isTopArrowIsNotVisible } from './isTopArrowIsNotVisible'

interface IProps {
  onChange: (field: string, index: number) => (value: string | number) => void
  getCrud: (index: number) => Crud<string, string | number>
  moveToTop: (index: number) => void
  moveToBottom: (index: number) => void
  dataLength: number
}

export const getSupportTopicColumns = ({
  onChange,
  getCrud,
  moveToTop,
  moveToBottom,
  dataLength,
}: IProps): IColumn<ISupportTopic>[] => {
  return [
    {
      titleRenderFn: () => getTopicAreaThView(),
      field: 'TopicArea',
      width: 200,
      renderComponent: ({ value, index }) => (
        <div className={styles.topicArea}>
          <DropdownAutocomplete<Record<string, string>>
            classes={{ input: styles.withoutBorder }}
            onChange={onChange('TopicArea', index)}
            value={value || ''}
            caption={'label'}
            source={getCrud(index)}
            mode="combobox"
            translation="jbp-hpcontactinfo-email-required"
          />
        </div>
      ),
    },
    {
      titleRenderFn: () => getTalkingPointsThView(),
      field: 'TalkingPoints',
      renderComponent: ({ value, index }) => (
        <div>
          <Textarea rows={3} value={value || ''} onChange={onChange('TalkingPoints', index)} />
          <div className={styles.moveIcons}>
            <i
              onClick={() => moveToTop(index)}
              className={classNames('kbase kbase-arrow-top', styles.moveIcons__icon, {
                [styles.hide]: isTopArrowIsNotVisible(index),
              })}
            />
            <i
              onClick={() => moveToBottom(index)}
              className={classNames('kbase kbase-arrow-bottom', styles.moveIcons__icon, {
                [styles.hide]: isBottomArrowIsNotVisible(index, dataLength),
              })}
            />
          </div>
        </div>
      ),
    },
  ]
}
